import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import {
  CreateLinkRequest
} from '../../services/magic-link/interfaces/ApiRequest'
import {
  createLink
} from '../../services/magic-link'

interface MagicLinkContextState extends BaseContextState {
  urlShortener: string | null
}

export interface MagicLinkContextData extends MagicLinkContextState {
  resetErrors: Function,

  requestCreateLink: (args: CreateLinkRequest) => Promise<string>
}

// Create context
const { Provider, Consumer } = createContext({} as MagicLinkContextData)

// Export consumer
export const MagicLinkConsumer = Consumer

export class MagicLinkProvider extends BaseContextProvider {
  state: MagicLinkContextState = {
    urlShortener: null
  }

  /**
   * Make api request for create magic link
   * 
   * @param {CreateLinkRequest} payload 
   */
   requestCreateLink = (payload: CreateLinkRequest): Promise<string> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null
      }, async () => {
        const response = await createLink(payload)
  
        // Process our response
        this.processResponse(response, { 
          mappings: {
            origin: 'url_shortener', destination: 'urlShortener'
          },
        })

        if (this.state.success && this.state.urlShortener) {
          resolve(this.state.urlShortener)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestCreateLink: this.requestCreateLink,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
